// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__2QV1Z","tab":"TabNav_tab__2EpKr","link":"TabNav_link__2BNyj","selectedLink":"TabNav_selectedLink__2c_tN","disabled":"TabNav_disabled__1kLaq"};